export const VIN_REGEX = /\b[A-HJ-NPR-Z\d]{17}\b/i;

export const LICENSE_PLATE_REGEX = /\b[A-Z]{2,3}[\s-]?[\dA-Z]{4,7}\b/i;